import { ShowPerPage } from "@/stores/showPerPage/showPerPage"
import { HttpRequestAxios } from "../../axios"
interface TypeList {
    page: number
}
interface TypeID {
    announceID: number
}

export async function GET_LIST_NOTIF(page = 1) {
    let data: TypeList = {
        page: page,
    }
    return await HttpRequestAxios({ url: '/announcement/list', data: data })
}

export async function POST_REMOVE_NOTIF(announcementID: number) {
    let data: TypeID = {
        announceID: announcementID
    }
    return await HttpRequestAxios({ url: '/announcement/remove', data: data })
}
export async function POST_ADD_NOTIF(data: number) {

    return await HttpRequestAxios({ url: '/announcement/add', data: data })
}

export async function GET_SELF_NOTIF(announcementID: number) {
    let data: TypeID = {
        announceID: announcementID
    }
    return await HttpRequestAxios({ url: '/announcement/get', data: data })
}

export async function POST_EDIT_NOTIF(data: any) {

    return await HttpRequestAxios({ url: '/announcement/update', data: data })

}

export async function POST_SEEN_NOTIF(ID: number) {
    let data = {
        announcementID: ID
    }
    return await HttpRequestAxios({ url: '/announcement/seen', data: data })
}

export async function GET_BADGE_NOTIF() {

    return await HttpRequestAxios({ url: '/announcement/badge' })
}
